import { useEffect, useState } from "react";
import { Loader2, AlertCircle } from "lucide-react";
import { log } from "@/lib/log";

const API = process.env.REACT_APP_BACKEND_URL;
// Garde anti double-appel (React StrictMode) en mémoire — le token n'est jamais écrit dans le navigateur.
const inflightTokens = new Set();

export default function PortalVerify() {
  const [error, setError] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      window.location.replace("/espace?err=invalid_or_expired");
      return;
    }
    if (inflightTokens.has(token)) return;
    inflightTokens.add(token);

    const fail = (err) => {
      if (err) log.error("[portal] vérification du lien impossible :", err);
      setError(true);
      setTimeout(() => { window.location.replace("/espace?err=invalid_or_expired"); }, 1200);
    };

    (async () => {
      try {
        const res = await fetch(`${API}/api/portal/verify?token=${encodeURIComponent(token)}`, {
          credentials: "include",
        });
        if (!res.ok) return fail();
        // Full page navigation so the dashboard mounts fresh with the session cookie.
        window.location.replace("/espace/dashboard");
      } catch (err) {
        fail(err);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center pt-28 pb-24 px-6" data-testid="portal-verify-page">
      <div className="text-center">
        {error ? (
          <>
            <AlertCircle className="text-gold mx-auto mb-6" size={32} strokeWidth={1.5} />
            <p className="text-xs uppercase tracking-luxe text-gold mb-4">Lien invalide</p>
            <h1 className="font-serif text-3xl md:text-4xl text-white mb-2">Ce lien a expiré.</h1>
            <p className="text-white/50 font-light">Redirection en cours…</p>
          </>
        ) : (
          <>
            <Loader2 className="text-gold mx-auto mb-6 animate-spin" size={32} strokeWidth={1.5} />
            <p className="text-xs uppercase tracking-luxe text-gold mb-4">Connexion sécurisée</p>
            <h1 className="font-serif text-3xl md:text-4xl text-white mb-2">Un instant…</h1>
            <p className="text-white/50 font-light">Vérification de votre lien en cours.</p>
          </>
        )}
      </div>
    </div>
  );
}
